export const INITIAL_STATE = {
  accessToken: null,
  user: {},
};
